import { formatMoney } from '@wit-support/ui-domain';
/** Где живёт страница запуска и форма нового запуска (путь модуля `fb-launches`). */
export const LAUNCHER_BASE = '/fb-launches';
export const launchPageHref = (launchId) => `${LAUNCHER_BASE}/launches/${launchId}`;
/** Ads Manager открывает объект на СВОЕЙ вкладке и по СВОЕМу параметру выбора. */
const ADS_MANAGER_TAB = {
    campaign: { tab: 'campaigns', param: 'selected_campaign_ids' },
    adset: { tab: 'adsets', param: 'selected_adset_ids' },
    ad: { tab: 'ads', param: 'selected_ad_ids' },
};
export const adsManagerHref = (adAccountId, kind, entityId) => {
    const act = (adAccountId ?? '').replace(/^act_/, '');
    const tab = ADS_MANAGER_TAB[kind];
    const q = new URLSearchParams({ [tab.param]: entityId });
    if (act)
        q.set('act', act);
    return `https://adsmanager.facebook.com/adsmanager/manage/${tab.tab}?${q.toString()}`;
};
export const LEVEL_PATH = {
    campaign: 'campaigns',
    adset: 'adsets',
    ad: 'ads',
};
/** Слова словаря макетов: ad set — «группа». */
export const KIND_WORD = {
    campaign: { nom: 'кампания', acc: 'кампанию', gen: 'кампании' },
    adset: { nom: 'группа', acc: 'группу', gen: 'группы' },
    ad: { nom: 'объявление', acc: 'объявление', gen: 'объявления' },
};
export const ORIGIN_LABEL = {
    launch: 'Запуск',
    duplicate: 'Копия',
    scale: 'SCALE',
    copy: 'Из Ads Manager',
    other: 'Другое',
};
export const STATE_FILTERS = [
    { value: 'all', label: 'Все' },
    { value: 'running', label: 'Крутятся' },
    { value: 'active', label: 'Включены' },
    { value: 'paused', label: 'На паузе' },
];
/** Статус объекта словами макета: «Крутится», «Включена, не крутится», «На паузе». */
export function statusView(o) {
    const eff = o.effectiveStatus ?? o.status;
    if (o.status === 'DELETED' || eff === 'DELETED') {
        return { label: 'Удалено', tone: 'red', paused: false, canPause: false };
    }
    if (o.status === 'ARCHIVED' || eff === 'ARCHIVED') {
        return { label: 'В архиве', tone: 'slate', paused: false, canPause: false };
    }
    if (o.status === 'PAUSED')
        return { label: 'На паузе', tone: 'slate', paused: true, canPause: false };
    if (eff === 'DISAPPROVED' || eff === 'WITH_ISSUES') {
        return { label: 'Включено, есть проблемы', tone: 'red', paused: false, canPause: true };
    }
    const running = o.running ?? eff === 'ACTIVE';
    return running
        ? { label: 'Крутится', tone: 'green', paused: false, canPause: true }
        : { label: 'Включено, не крутится', tone: 'amber', paused: false, canPause: true };
}
/** «Включена» / «Включено» по роду объекта в подписи статуса. */
export function statusLabelFor(kind, v) {
    if (kind === 'campaign' && v.label.startsWith('Включено')) {
        return v.label.replace('Включено', 'Включена');
    }
    if (kind === 'adset' && v.label.startsWith('Включено'))
        return v.label.replace('Включено', 'Включена');
    if (v.label === 'Удалено' && kind !== 'ad')
        return 'Удалена';
    if (v.label === 'В архиве' && kind !== 'ad')
        return 'В архиве';
    return v.label;
}
export const money = (minor, currency) => formatMoney(minor, currency);
/** Целые доллары без копеек для «до $86 в день». */
export function moneyShort(minor, currency) {
    const s = formatMoney(minor, currency);
    return s.replace(/[.,]00(?=\D*$)/, '');
}
/** Предупреждения статус-проверки — русскими словами по коду; тексты auto-ads (EN) наружу не идут. */
const WARNING_RU = {
    'rule-conflict': 'Правило может снова поставить объект на паузу.',
    'rule-check-unavailable': 'Не удалось проверить правила — включение пройдёт без проверки.',
    'parent-paused': 'Родитель на паузе — показ не начнётся, пока его не включить.',
    'no-active-children': 'Внутри нет включённых объектов — показ не начнётся.',
    'status-not-switchable': 'У объекта такой статус, что включить его нельзя.',
    'budget-unknown': 'Бюджет не найден — сумму в день назвать не можем.',
    'managed-by-launch': 'Создано запуском конструктора.',
    'launch-rollback-needs-force': 'Объект включён отдельно от запуска — откат такого запуска теперь потребует принудительного режима.',
    'already-in-target-status': 'Объект уже в нужном статусе.',
    'pending-enable-timer': 'Есть запланированное включение.',
    'grace-active': 'У объекта уже есть грейс.',
    'grace-not-applied': 'Уже включено — грейс не добавлен.',
    'launch-lookup-unavailable': 'Не удалось проверить, создана ли кампания запуском.',
    'children-unavailable': 'Не удалось проверить группы и объявления внутри — сумма и то, начнёт ли кампания крутиться, могут быть неточными.',
};
export const warningText = (code) => WARNING_RU[code] ?? null;
/** Для итога включения: показываем ВСЕ предупреждения ответа; незнакомый код — общей фразой (EN-текст не идёт). */
export const warningTextAny = (code) => WARNING_RU[code] ?? 'Сервис рекламы передал предупреждение — проверьте объект в Meta.';
const EFFECT_RU = {
    'may-pause': 'может поставить на паузу',
    'may-enable': 'может включить',
    'may-change-budget': 'может поменять бюджет',
};
export const ruleEffectText = (effect) => EFFECT_RU[effect] ?? 'действует на объект';
/** Дата-время «26.10 18:40» без секунд, в часовом поясе браузера. */
export function shortWhen(iso) {
    if (!iso)
        return null;
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return null;
    const p = (n) => String(n).padStart(2, '0');
    return `${p(d.getDate())}.${p(d.getMonth() + 1)} ${p(d.getHours())}:${p(d.getMinutes())}`;
}
/** То же, но по Лос-Анджелесу — пояс, в котором живут расписания кабинетов Meta. */
export function laWhen(iso) {
    if (!iso)
        return null;
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return null;
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'America/Los_Angeles',
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).formatToParts(d);
    const get = (t) => parts.find((p) => p.type === t)?.value ?? '';
    return `${get('day')}.${get('month')} ${get('hour')}:${get('minute')}`;
}
const ISO_IN_TEXT = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})/;
/**
 * Предупреждение результата паузы: у таймера правила время — в `message`
 * (отдельного поля нет), время показываем по Лос-Анджелесу; не распарсилось —
 * «позже». Остальные коды — общим маппером.
 */
export function pauseWarningText(w) {
    if (w.code === 'rule-timer-will-enable') {
        const at = laWhen(ISO_IN_TEXT.exec(w.message)?.[0] ?? null);
        return at ? `Правило снова включит объект ${at}` : 'Правило снова включит объект позже';
    }
    return warningTextAny(w.code);
}
/** Заметка ответа паузы о ждущих включениях — известный текст на русский, EN наружу не идёт. */
export function pendingNoteText(note) {
    return note === 'rule timers are not cancelled'
        ? 'Таймеры правил не отменяются — они только показаны.'
        : 'У объекта остались запланированные включения — подробности в журнале.';
}
/** Сумма в день при включении: из структурных полей проверки, не из EN-заметки `spend.note`. */
export function enableSpendText(s) {
    const sp = s.spend;
    if (!sp)
        return null;
    const cur = sp.currency || 'USD';
    const where = s.level === 'campaign'
        ? sp.budgetLevel === 'adset'
            ? 'сумма бюджетов включённых групп'
            : 'бюджет кампании'
        : s.level === 'adset'
            ? 'бюджет группы'
            : sp.budgetLevel === 'campaign'
                ? 'бюджет кампании'
                : 'бюджет группы';
    if (sp.dailyBudgetMinor !== null)
        return `до ${moneyShort(sp.dailyBudgetMinor, cur)} в день (${where})`;
    if (sp.lifetimeBudgetMinor !== null) {
        return `бюджет на весь срок ${moneyShort(sp.lifetimeBudgetMinor, cur)} (${where})`;
    }
    return null;
}
export function isRowRunning(r) {
    return r.running;
}
//# sourceMappingURL=format.js.map